// Yükleme sınırları ve "bu adres video mu" kararı tek yerdedir.
//
// Sınır bir süre on beş ayrı ekranda `5 * 1024 * 1024` olarak yazılıydı;
// backend tavanı değiştiğinde hepsini bulmak gerekiyordu ve unutulan ekran
// dosyayı kapıda reddedip yöneticiye yanlış sebebi söylüyordu. Değerler
// backend'deki `services/media_upload.py` ile **aynı kalmalıdır**: istemci
// kontrolü bir kolaylıktır, asıl kapı sunucudadır.

export const UPLOAD_MAX_BYTES = 50 * 1024 * 1024;
export const UPLOAD_MAX_LABEL = '50 MB';

// Yükleme penceresinin dosya süzgeci. Tarayıcı bunu bir öneri sayar (dosya
// yine de seçilebilir), gerçek doğrulama sunucudaki imza kontrolüdür.
export const IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp,image/svg+xml';
// Hareketli oyun kartı: yalnızca oyun görseli ucunda video kabul edilir.
export const GAME_ARTWORK_ACCEPT = `${IMAGE_ACCEPT},video/mp4,video/webm`;

const VIDEO_EXTENSIONS = ['.mp4', '.webm'];

/** Dosya tavanı aşıyorsa `true`. */
export function uploadTooLarge(file) {
  return Boolean(file) && file.size > UPLOAD_MAX_BYTES;
}

/**
 * Adres hareketli bir video mu?
 *
 * Ölçü uzantıdır: yüklenen dosyanın adını sunucu üretir
 * (`<32 hex>.mp4`) ve sağlayıcıdan gelen mutlak adreslerde video hiç
 * bulunmaz. Sorgu dizesi ve çapa kırpılır — CDN adresleri `?v=2` gibi
 * ekler taşıyabiliyor ve ham karşılaştırma onları kaçırırdı.
 */
export function isVideoAsset(url) {
  if (typeof url !== 'string') return false;
  const path = url.split(/[?#]/)[0].toLowerCase();
  return VIDEO_EXTENSIONS.some((extension) => path.endsWith(extension));
}
